import { callTokenApi } from '../apiCaller';
import {
     API_CLIENT_COUNT_FORM_INVENTORY,
     API_CLIENT_FETCH_CHILD_FORM_IGNORED,
     API_CLIENT_FETCH_CHILD_FORM_INVENTORY,
     API_CLIENT_FETCH_FORM_INVENTORY_LISTENER,
     API_CLIENT_FORM_IGNORED,
     API_CLIENT_UPDATE_IS_REDIRECT,
     API_CLIENT_UPDATE_REVEAL_PEOPLE,
     API_VERSION_WAITING,
     CLIENT_LISTENER,
     LISTENER_TYPE,
} from '../constants';
import { toastError } from '../utils';
import {
     ADMIN_INCREMENT_NUMBER_HISTORIES,
     ADMIN_SET_PUSHER_CHANNEL_NAME,
     ADMIN_SET_PUBLISHED_ACCOUNTS,
     ADMIN_SET_PUBLISHING_ACCOUNTS,
     ADMIN_SET_ACCOUNT,
     SET_SUBSCRIBER_STATE,
     SET_FORM_INVENTORY,
     FORM_CATEGORY_SET_ALL_FORMS_INVENTORY,
     SET_COUNT_FORM_INVENTORY,
     FORM_CATEGORY_SET_ALL_FORMS_IGNORE,
     SET_FORM_IGNORED,
     SET_INITIAL_PERSONAL_DATA,
     SET_FORM_REQUIRING_ACTION,
     FORM_CATEGORY_SET_FORM_EDIT,
     FORM_REQUIRING_SET_ALL_FORMS,
     FORM_IGNORE_SET_FORM_EDIT,
     SET_LISTENER_FORMS_ENABLED,
     SET_LOADINGS,
     SET_ACTIVE_LISTENERS,
     SET_ACTIVE_ACCOUNT_GOAL,
     SET_SHOW_IGNORED_INVENTORY_FORM,
     FORM_CATEGORY_SET_LIST_FORM_CHILDS,
     FORM_CATEGORY_SET_FILTERS,
     SET_VERSION_PUBLISH,
     SET_VERSIONS,
     SET_NUMBER_HISTORIES,
     SET_SHOW_PUBLISH_POPUP,
     ADMIN_SET_FLEXIBLE_MODAL,
     SET_CURRENT_INDEX_SPLIT,
} from './types';
import findIndex from 'lodash/findIndex';

export const adminSetIncrementHistories = () => {
     return {
          type: ADMIN_INCREMENT_NUMBER_HISTORIES,
     };
};

export const setPusherChannelName = (channelName) => {
     return {
          type: ADMIN_SET_PUSHER_CHANNEL_NAME,
          payload: channelName,
     };
};

export const setPublishedAccounts = (accounts) => {
     return {
          type: ADMIN_SET_PUBLISHED_ACCOUNTS,
          payload: accounts,
     };
};

export const setPublishingAccounts = (accounts) => {
     return {
          type: ADMIN_SET_PUBLISHING_ACCOUNTS,
          payload: accounts,
     };
};

export const setAccountAdmin = (account) => {
     return {
          type: ADMIN_SET_ACCOUNT,
          payload: account,
     };
};

export const setSubscriberState = (state) => {
     return {
          type: SET_SUBSCRIBER_STATE,
          payload: state,
     };
};

export const setFormInventory = (formInventory) => {
     return {
          type: SET_FORM_INVENTORY,
          payload: formInventory,
     };
};

export const setAllFormsInventory = (forms) => {
     return {
          type: FORM_CATEGORY_SET_ALL_FORMS_INVENTORY,
          payload: forms,
     };
};

export const setAllFormsRequiring = (forms) => {
     return {
          type: FORM_REQUIRING_SET_ALL_FORMS,
          payload: forms,
     };
};

export const setFormIgnoreEdit = (forms) => {
     return {
          type: FORM_IGNORE_SET_FORM_EDIT,
          payload: forms,
     };
};

export const setCountFormInventory = (countFormInventory) => {
     return {
          type: SET_COUNT_FORM_INVENTORY,
          payload: countFormInventory,
     };
};

export const setAllFormsIgnore = (forms) => {
     return {
          type: FORM_CATEGORY_SET_ALL_FORMS_IGNORE,
          payload: forms,
     };
};

export const setFormIgnored = (formIgnored) => {
     return {
          type: SET_FORM_IGNORED,
          payload: formIgnored,
     };
};

export const setInitialPersonalData = (personalData) => {
     return {
          type: SET_INITIAL_PERSONAL_DATA,
          payload: personalData,
     };
};

export const setFormRequiringAction = (forms) => {
     return {
          type: SET_FORM_REQUIRING_ACTION,
          payload: forms,
     };
};

export const setFormInventoryEdit = (forms) => {
     return {
          type: FORM_CATEGORY_SET_FORM_EDIT,
          payload: forms,
     };
};

export const setFlexibleModal = (flexibleModal) => {
     return {
          type: ADMIN_SET_FLEXIBLE_MODAL,
          payload: flexibleModal
     }
}

export const setListenerFormsEnabled = (listeners) => {
     return {
          type: SET_LISTENER_FORMS_ENABLED,
          payload: listeners,
     };
};

export const setLoadings = (loadings) => {
     return {
          type: SET_LOADINGS,
          payload: loadings,
     };
};

export const setActiveListeners = (listeners) => {
     return {
          type: SET_ACTIVE_LISTENERS,
          payload: listeners,
     };
};

export const setActiveAccountGoals = (accountGoals) => {
     return {
          type: SET_ACTIVE_ACCOUNT_GOAL,
          payload: accountGoals,
     };
};

export const setShowIgnoredInventoryForm = (showIgnoredInventoryForm) => {
     return {
          type: SET_SHOW_IGNORED_INVENTORY_FORM,
          payload: showIgnoredInventoryForm,
     };
};

export const setFilterFormCategories = (filters) => {
     return {
          type: FORM_CATEGORY_SET_FILTERS,
          payload: filters,
     };
};

export const setListFormsChild = (forms) => {
     return {
          type: FORM_CATEGORY_SET_LIST_FORM_CHILDS,
          payload: forms,
     };
};

export const setVersionPublish = (options) => {
     return {
          type: SET_VERSION_PUBLISH,
          payload: options,
     };
};

export const setVersions = (options) => {
     return {
          type: SET_VERSIONS,
          payload: options,
     };
};

export const setShowPublishPopup = (show) => {
     return {
          type: SET_SHOW_PUBLISH_POPUP,
          payload: show,
     };
};

export const setNumberOfHistories = (options) => {
     return {
          type: SET_NUMBER_HISTORIES,
          payload: options,
     };
};
export const setCurrentIndexSplit = (index) => {
     return {
          type: SET_CURRENT_INDEX_SPLIT,
          payload: index,
     };
};

export const handleSetListenerFormsEnabled = () => (dispatch, getState) => {
     const activeListeners = getState().admin.activeListeners;
     const listenerFormEnabled = activeListeners.filter((listener) => listener.configStatus && listener.type === LISTENER_TYPE.FORMS);
     dispatch(setListenerFormsEnabled(listenerFormEnabled));
};

export const handleFetchCountFormsInventory =
     (nextDispatch, activeAccount, filters = []) =>
          (dispatch, getState) => {
               let newActiveAccount = activeAccount;
               let filterQuery = '';

               if (!activeAccount) {
                    newActiveAccount = getState().admin.accountAdmin;
               }
               const { id: accountId } = newActiveAccount;

               nextDispatch?.setIsLoading?.(true);
               dispatch(setSubscriberState({ inventoryCountLoading: true }));

               filters.forEach((filter) => {
                    if (filter.type) {
                         const filterValue = filter.value.trim() ? filter.value : '';
                         filterQuery = `${filterQuery}&filter.${filter.type}.${filter.operator}=${filterValue}`;
                    }
               });

               if (accountId && accountId !== '') {
                    callTokenApi(`${API_CLIENT_COUNT_FORM_INVENTORY.replace(':accountId', accountId)}?${filterQuery}`, 'GET')
                         .then((response) => {
                              if (response.status === 200) {
                                   const countFormInventory = response.data.countForms;
                                   dispatch(setCountFormInventory(countFormInventory));
                              } else {
                                   toastError(response);
                              }
                         })
                         .finally(() => {
                              nextDispatch?.setIsLoading?.(false);
                              dispatch(setSubscriberState({ inventoryCountLoading: false }));
                         });
               }
          };

export const handleFetchFormsIgnored =
     (limit, next, numberPage = 0) =>
          (dispatch, getState) => {
               const activeAccount = getState().admin.accountAdmin;

               const newStateSet = {};
               let firstLoad,
                    numberOffset = 0;

               if (next) {
                    firstLoad = { ignoredFormsLoading: true };
                    numberOffset = numberPage * 20;
               } else {
                    firstLoad = { ignoredLoading: true };
               }

               dispatch(setSubscriberState(firstLoad));

               callTokenApi(`${API_CLIENT_FORM_IGNORED.replace(':accountId', activeAccount.id)}?limit=${limit}&offset=${numberOffset}`, 'GET')
                    .then((response) => {
                         if (response.status === 200) {
                              const listForms = response.data.formAccount;

                              if (next) {
                                   if (listForms?.length > 0) {
                                        const newAllForms = [...listForms].splice(0, limit);
                                        dispatch(setAllFormsIgnore(newAllForms));
                                   } else {
                                        newStateSet.ignoredDisableNextPage = true;

                                        if (numberPage === 1) {
                                             dispatch(setSubscriberState({ ignoredShowPaging: false }));
                                        }
                                   }
                              } else {
                                   // first load
                                   const newForms = [...listForms].splice(0, 12);
                                   const newAllForms = [...listForms].splice(0, limit);

                                   dispatch(setFormIgnored(newForms));
                                   dispatch(setAllFormsIgnore(newAllForms));

                                   if (listForms.length <= limit) {
                                        dispatch(setSubscriberState({ ignoredShowPaging: false }));
                                   } else {
                                        dispatch(setSubscriberState({ ignoredShowPaging: true }));
                                   }
                              }

                              if (listForms?.length > 0) {
                                   newStateSet.ignoredNumberPerpage = numberPage || 0;
                              }

                              if (listForms.length <= limit) {
                                   newStateSet.ignoredDisableNextPage = true;
                              } else {
                                   newStateSet.ignoredDisableNextPage = false;
                              }
                         } else {
                              toastError(response);
                         }
                    })
                    .finally(() => {
                         if (next) {
                              newStateSet.ignoredFormsLoading = false;
                         } else {
                              newStateSet.ignoredLoading = false;
                         }

                         dispatch(setSubscriberState(newStateSet));
                    });
          };

export const handleFetchFormsInventory =
     (limit, next, numberPage = 0, filters = []) =>
          (dispatch, getState) => {
               const activeAccount = getState().admin.accountAdmin;
               const newStateSet = {};
               let firstLoad,
                    numberOffset = 0;
               let filterQuery = '';

               if (next) {
                    firstLoad = { inventoryFormsLoading: true };
                    numberOffset = numberPage * 20;
               } else {
                    firstLoad = { inventoryLoading: true };
               }

               dispatch(setSubscriberState(firstLoad));

               filters.forEach((filter) => {
                    if (filter.type) {
                         const filterValue = filter.value.trim() ? filter.value : '';
                         filterQuery = `${filterQuery}&filter.${filter.type}.${filter.operator}=${filterValue}`;
                    }
               });

               callTokenApi(
                    `${API_CLIENT_FETCH_FORM_INVENTORY_LISTENER.replace(
                         ':accountId',
                         activeAccount.id
                    )}?limit=${limit}&offset=${numberOffset}${filterQuery}`,
                    'GET'
               )
                    .then((response) => {
                         if (response.status === 200) {
                              const listFormInventory = response.data.formAccount;

                              if (next) {
                                   if (listFormInventory?.length > 0) {
                                        const newAllForms = [...listFormInventory].splice(0, limit);
                                        dispatch(setAllFormsInventory(newAllForms));
                                   } else {
                                        newStateSet.inventoryDisableNextPage = true;

                                        if (numberPage === 1) {
                                             dispatch(setSubscriberState({ inventoryShowPaging: false }));
                                        }
                                   }
                              } else {
                                   // first load
                                   const newForms = [...listFormInventory].splice(0, 12);
                                   const newAllForms = [...listFormInventory].splice(0, limit);

                                   dispatch(setFormInventory(newForms));
                                   dispatch(setAllFormsInventory(newAllForms));

                                   if (listFormInventory.length <= limit) {
                                        dispatch(setSubscriberState({ inventoryShowPaging: false }));
                                   } else {
                                        dispatch(setSubscriberState({ inventoryShowPaging: true }));
                                   }
                              }

                              if (listFormInventory?.length > 0) {
                                   newStateSet.inventoryNumberPerpage = numberPage || 0;
                              }

                              if (listFormInventory.length <= limit) {
                                   newStateSet.inventoryDisableNextPage = true;
                              } else {
                                   newStateSet.inventoryDisableNextPage = false;
                              }
                         } else {
                              toastError(response);
                         }
                    })
                    .finally(() => {
                         if (next) {
                              newStateSet.inventoryFormsLoading = false;
                         } else {
                              newStateSet.inventoryLoading = false;
                         }

                         dispatch(setSubscriberState(newStateSet));
                    });
          };

export const handleUpdateRevealPeople = (values, parentId, nextDispatch) => (dispatch, getState) => {
     const { data } = values;
     const formInventory = getState().admin.formInventory;
     const allFormsInventory = getState().admin.allFormsInventory;
     const formInventoryEdit = getState().admin.formInventoryEdit || [];
     const listFormChild = getState().admin[data.id] || [];
     const listFormChildParent = getState().admin[parentId] || [];

     if (nextDispatch.setLoading) {
          nextDispatch.setLoading(true);
     }

     if (data.hasChild) {
          listFormChild.map((item) => {
               if (item.inheritParent) {
                    item.revealPeople = data.revealPeople;
               }
               return item;
          });
     } else if (parentId) {
          listFormChildParent.map((item) => {
               if (item.id === data.id) {
                    item.revealPeople = data.revealPeople;
               }
               return item;
          });
     }

     const newFormInventory = formInventory.map((item) => {
          if (item.id === data.id) {
               item.revealPeople = data.revealPeople;
          }
          return item;
     });

     const newAllFormInventory = allFormsInventory.map((item) => {
          if (item.id === data.id) {
               item.revealPeople = data.revealPeople;
          }
          return item;
     });

     callTokenApi(API_CLIENT_UPDATE_REVEAL_PEOPLE, 'PUT', values)
          .then((response) => {
               if (response.status === 200) {
                    dispatch(
                         setSubscriberState({
                              [data.id]: listFormChild,
                         })
                    );
                    dispatch(
                         setSubscriberState({
                              [parentId]: listFormChildParent,
                         })
                    );
                    dispatch(setFormInventory(newFormInventory));
                    dispatch(setAllFormsInventory(newAllFormInventory));

                    formInventoryEdit.forEach((form) => {
                         if (form.id === data.id || (form.inheritParent && form.parentId === data.id)) {
                              form.revealPeople = data.revealPeople;
                              dispatch(setFormInventoryEdit(form));
                         }
                    });
               } else {
                    toastError(response);
               }
          })
          .finally(() => {
               nextDispatch.setLoading(false);
          });
};

export const handleUpdateIsRedirectInventory = (values, parentId, nextDispatch) => (dispatch, getState) => {
     const { data } = values;
     const formInventory = getState().admin.formInventory;
     const allFormsInventory = getState().admin.allFormsInventory;
     const formInventoryEdit = getState().admin.formInventoryEdit || [];
     const listFormChild = getState().admin[data.id] || [];
     const listFormChildParent = getState().admin[parentId] || [];
     let newFormInventory = [];
     let newAllFormInventory = [];

     if (nextDispatch.setLoading) {
          nextDispatch.setLoading(true);
     }

     if (data.hasChild) {
          listFormChild.map((item) => {
               if (item.inheritParent) {
                    item.isRedirect = data.isRedirect;
               }
               return item;
          });
     } else if (parentId) {
          listFormChildParent.map((item) => {
               if (item.id === data.id) {
                    item.isRedirect = data.isRedirect;
               }
               return item;
          });
     }

     newFormInventory = formInventory.map((item) => {
          if (item.id === data.id) {
               item.isRedirect = data.isRedirect;
          }
          return item;
     });

     newAllFormInventory = allFormsInventory.map((item) => {
          if (item.id === data.id) {
               item.isRedirect = data.isRedirect;
          }
          return item;
     });

     callTokenApi(API_CLIENT_UPDATE_IS_REDIRECT, 'PUT', values)
          .then((response) => {
               if (response.status === 200) {
                    dispatch(
                         setSubscriberState({
                              [data.id]: listFormChild,
                         })
                    );
                    dispatch(
                         setSubscriberState({
                              [parentId]: listFormChildParent,
                         })
                    );
                    dispatch(setFormInventory(newFormInventory));
                    dispatch(setAllFormsInventory(newAllFormInventory));

                    formInventoryEdit.forEach((form) => {
                         if (form.id === data.id || (form.inheritParent && form.parentId === data.id)) {
                              form.isRedirect = data.isRedirect;
                              dispatch(setFormInventoryEdit(form));
                         }
                    });
               } else {
                    toastError(response);
               }
          })
          .finally(() => {
               nextDispatch.setLoading(false);
          });
};

export const handleUpdateIsRedirectIgnored = (values, parentId, nextDispatch) => (dispatch, getState) => {
     const { data } = values;
     const listFormIgnored = getState().admin.formIgnored;
     const allFormsIgnored = getState().admin.allFormsIgnored;
     const formIgnoreEdit = getState().admin.formIgnoreEdit || [];
     const listChildIgnored = getState().admin[`ignored${data.id}`] || [];
     const listFormChildIgnoredParent = getState().admin[`ignored${parentId}`] || [];
     let newFormIgnored = [];
     let newAllFormIgnored = [];

     if (nextDispatch.setLoading) {
          nextDispatch.setLoading(true);
     }

     if (data.hasChild) {
          listChildIgnored.map((item) => {
               if (item.inheritParent) {
                    item.isRedirect = data.isRedirect;
               }
               return item;
          });
     } else if (parentId) {
          listFormChildIgnoredParent.map((item) => {
               if (item.id === data.id) {
                    item.isRedirect = data.isRedirect;
               }
               return item;
          });
     }

     newFormIgnored = listFormIgnored.map((item) => {
          if (item.id === data.id) {
               item.isRedirect = data.isRedirect;
          }
          return item;
     });

     newAllFormIgnored = allFormsIgnored.map((item) => {
          if (item.id === data.id) {
               item.isRedirect = data.isRedirect;
          }
          return item;
     });

     callTokenApi(API_CLIENT_UPDATE_IS_REDIRECT, 'PUT', values)
          .then((response) => {
               if (response.status === 200) {
                    dispatch(
                         setSubscriberState({
                              [`ignored${data.id}`]: listChildIgnored,
                         })
                    );
                    dispatch(
                         setSubscriberState({
                              [`ignored${parentId}`]: listFormChildIgnoredParent,
                         })
                    );
                    dispatch(setFormIgnored(newFormIgnored));
                    dispatch(setAllFormsIgnore(newAllFormIgnored));

                    formIgnoreEdit.forEach((form) => {
                         if (form.id === data.id || (form.inheritParent && form.parentId === data.id)) {
                              form.isRedirect = data.isRedirect;
                              dispatch(setFormIgnoreEdit(form));
                         }
                    });
               } else {
                    toastError(response);
               }
          })
          .finally(() => {
               nextDispatch.setLoading(false);
          });
};

export const fetchListeners = (activeAccountId) => {
     return (dispatch) => {
          dispatch(setLoadings({ listeners: true, destinations: true }));

          if (activeAccountId) {
               callTokenApi(`${CLIENT_LISTENER}${activeAccountId}`, 'GET', null).then((response) => {
                    if (response.status === 200) {
                         const { accountListeners, accountGoals } = response.data;
                         let enabledListeners = accountListeners.filter((listener) => listener.configStatus);
                         
                         dispatch(setActiveAccountGoals(accountGoals?.filter(accountGoal => accountGoal.status)));

                         if (enabledListeners.length > 0) {
                              dispatch(setActiveListeners(enabledListeners));
                         } else {
                              dispatch(setActiveListeners([]));
                              dispatch(setLoadings({ listeners: false, destinations: false }));
                         }
                    } else {
                         toastError(response);
                         dispatch(setLoadings({ listeners: false, destinations: false }));
                    }
               });
          }
     };
};

export const handleFetchChildForm =
     (id, nextDispatch, limit, paging, filters = []) =>
          (dispatch, getState) => {
               let listFormsChild = [];
               let filterQuery = '';
               const showIgnoredInventoryForm = getState().admin.showIgnoredInventoryForm;
               const numberOffsetChild = paging ? getState().admin[`numberOffset${id}`] : 0;

               nextDispatch?.setLoading?.(true);
               nextDispatch?.setisLoadingLoadMore?.(true);

               if (!showIgnoredInventoryForm) {
                    listFormsChild = paging ? getState().admin[id] : [];
               } else {
                    listFormsChild = paging ? getState().admin[`ignored${id}`] : [];
               }

               const url = showIgnoredInventoryForm ? API_CLIENT_FETCH_CHILD_FORM_IGNORED : API_CLIENT_FETCH_CHILD_FORM_INVENTORY;

               filters.forEach((filter) => {
                    if (filter.type) {
                         const filterValue = filter.value.trim() ? filter.value : '';
                         filterQuery = `${filterQuery}&filter.${filter.type}.${filter.operator}=${filterValue}`;
                    }
               });

               callTokenApi(`${url.replace(':parentId', id)}?limit=${limit}&offset=${listFormsChild.length}${filterQuery}`, 'GET')
                    .then((response) => {
                         if (response.status === 200) {
                              const listFormResponse = response.data.formAccount;
                              const newListForms = limit ? [...listFormsChild, ...listFormResponse] : listFormResponse;
                              const newNumber = numberOffsetChild + listFormResponse.length;
                              if (!showIgnoredInventoryForm) {
                                   dispatch(
                                        setListFormsChild({
                                             [id]: newListForms,
                                             [`numberOffset${id}`]: newNumber,
                                        })
                                   );
                              } else {
                                   dispatch(
                                        setListFormsChild({
                                             [`ignored${id}`]: newListForms,
                                             [`numberOffset${id}`]: newNumber,
                                        })
                                   );
                              }

                              if (newNumber < numberOffsetChild + limit || newNumber < limit) {
                                   nextDispatch?.setShowLoadMoreBtn?.(false);
                              }
                         } else {
                              toastError(response);
                         }
                    })
                    .finally(() => {
                         nextDispatch?.setLoading?.(false);
                         nextDispatch?.setFetched?.(true);
                         nextDispatch?.setisLoadingLoadMore?.(false);
                    });
          };

export const fetchVersion = (accountId, flag) => {
     return (dispatch) => {
          const data = {
               accountId: accountId,
               status: 'waiting',
          };
          callTokenApi(`${API_VERSION_WAITING}`, 'POST', data).then((response) => {
               if (response.status === 200) {
                    let isPublish = parseInt(response.data.version.numberHistories) > 0 ? 'enable' : 'disable';
                    dispatch(setVersions(response.data.versions));
                    dispatch(setVersionPublish({ version: response.data.version, isPublish }));
                    if (flag) {
                         if (isPublish === 'enable') {
                              dispatch(setNumberOfHistories(parseInt(response.data.version.numberHistories)));
                         } else {
                              dispatch(setNumberOfHistories(0));
                         }
                    }
               } else {
                    toastError(response);
               }
          });
     };
};

export const startSplitPerson = () => {
     return (dispatch, getState) => {
          const publishedAccounts = getState().admin.publishedAccounts;
          const pusherChannelName = getState().admin.pusherChannelName;
          const currentIndexSplit = getState().admin.currentIndexSplit;

          if (!publishedAccounts[currentIndexSplit]) {
               return;
          }

          const newPublishedAccounts = [...publishedAccounts];
          newPublishedAccounts[currentIndexSplit].statusSplit = 'loading';
          newPublishedAccounts[currentIndexSplit].status = 'waiting';

          dispatch(setPublishedAccounts(newPublishedAccounts));

          const accountId = publishedAccounts[currentIndexSplit].id.trim();
          callTokenApi('admin/person/split', 'POST', { accountId, pusherChannelName }).then(async (response) => {
               const newPublishedAccounts = [...publishedAccounts];

               if (response.status === 200) {
                    const { statusSplit } = response.data.account;

                    if (statusSplit === 'success') {
                         newPublishedAccounts[currentIndexSplit].status = 'success';
                         newPublishedAccounts[currentIndexSplit].statusSplit = 'success';
                         newPublishedAccounts[currentIndexSplit].numberIdentifier = 0;
                         newPublishedAccounts[currentIndexSplit].numberPerson = 0;

                         if (currentIndexSplit < publishedAccounts.length) {
                              dispatch(setCurrentIndexSplit(currentIndexSplit + 1));
                              dispatch(startSplitPerson());
                         }
                    } else {
                         newPublishedAccounts[currentIndexSplit].statusSplit = 'running';
                    }
                    dispatch(setPublishedAccounts(newPublishedAccounts));
               } else {
                    newPublishedAccounts[currentIndexSplit].statusSplit = 'failed';
                    dispatch(setPublishedAccounts(newPublishedAccounts));

                    if (currentIndexSplit < publishedAccounts.length) {
                         dispatch(setCurrentIndexSplit(currentIndexSplit + 1));
                         dispatch(startSplitPerson());
                    }
               }

          }).catch((err) => {
               console.log('err :>> ', err);
          });
     };
};

export const handleSplitCompleted = (data) => {
     return (dispatch, getState) => {
          const { accountId, numberIdentifier } = data;

          const publishedAccounts = getState().admin.publishedAccounts;
          const pusherChannelName = getState().admin.pusherChannelName;

          const newPublishedAccounts = [...publishedAccounts];
          const index = findIndex(newPublishedAccounts, { id: accountId });
          newPublishedAccounts[index].status = 'running';
          newPublishedAccounts[index].numberIdentifier = numberIdentifier;
          newPublishedAccounts[index].statusSplit = 'success';

          dispatch(setPublishedAccounts(newPublishedAccounts));

          callTokenApi('/admin/person/merge', 'POST', { accountId: accountId.trim(), pusherChannelName }).then((response) => {
               if (response.status === 200) {
                    // Refresh the table data

               } else {
                    toastError(response);
               }
          });
     }
};

export const handleMergePersonCompleted = (data) => {
     return (dispatch, getState) => {
          const { accountId, numberPerson } = data;
          const publishedAccounts = getState().admin.publishedAccounts;
          const currentIndexSplit = getState().admin.currentIndexSplit;
          const index = findIndex(publishedAccounts, { id: accountId });

          const newPublishedAccounts = [...publishedAccounts];
          newPublishedAccounts[index].status = 'success';
          newPublishedAccounts[index].numberPerson = numberPerson;

          dispatch(setPublishedAccounts(newPublishedAccounts));

          // Refresh the table data
          if (currentIndexSplit < publishedAccounts.length) {
               dispatch(setCurrentIndexSplit(currentIndexSplit + 1));
               dispatch(startSplitPerson());
          }
     }
};